import { axios } from '@ben/api/axios';
import type { CustomComponentTypes } from '@ben/shared/constants/custom-component-types';
import type {
  IComponent,
  IModularBenefitDetail,
} from '@ben/shared/types/columbia';
import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

export interface AirtableFetchData {
  benefitData: Partial<IModularBenefitDetail> & {
    components?: IComponent[];
  };
  importErrors: string[];
  componentImportErrors: CustomComponentTypes[];
  successfulImportsCount: number;
}

const fetchFromAirtable = async (airtableId: string) => {
  const response = await axios.get<AirtableFetchData>(
    `benefits/fetch-from-airtable?airtable_id=${airtableId}`
  );
  return response.data;
};

export const useMutationAirtableFetch = (
  options?: UseMutationOptions<AirtableFetchData, unknown, string>
) => {
  return useMutation<AirtableFetchData, unknown, string>({
    ...options,
    mutationFn: (airtableId?: string) => {
      if (!airtableId) {
        return Promise.reject(new Error('airtableId must be provided'));
      }
      return fetchFromAirtable(airtableId);
    },
  });
};
